import type { FC, Dispatch, SetStateAction } from 'react';

import cn from 'classnames';

import { minutes, hours } from 'library/helpers/events/timePicker';

import * as st from './TimePopUp.module.scss';

interface Props {
	setChecked: Dispatch<SetStateAction<{ hours: string; minutes: string }>>;
	value: string;
	index: number;
	checked: {
		hours: string;
		minutes: string;
	};
	onChange: (value: string | Date) => void;
	getDate: (value: string, index: number) => Date;
	handler: () => void;
}

const TimePopUp: FC<Props> = ({
	setChecked,
	value,
	onChange,
	handler,
	index,
	getDate,
	checked,
}) => {
	return (
		<div className={st.popap}>
			<div className={st.header}>{value}</div>
			<div className={st.line} />
			<div className={st.main}>
				<div className={st.time}>
					<div className={st.select}>
						{hours.map((item, index) => (
							<div
								className={cn(st.option, item === checked?.hours && st.active)}
								key={index}
								onClick={() => {
									setChecked((prevState) => ({
										...prevState,
										hours: item,
									}));
								}}
							>
								{item}
							</div>
						))}
					</div>
				</div>

				<div className={st.time}>
					<div className={st.select}>
						{minutes.map((item, index) => (
							<div
								className={cn(st.option, item === checked?.minutes && st.active)}
								key={index}
								onClick={() => {
									setChecked((prevState) => ({
										...prevState,
										minutes: item,
									}));
								}}
							>
								{item}
							</div>
						))}
					</div>
				</div>
			</div>
			<button
				type="button"
				className={st.button}
				onClick={() => {
					onChange(getDate(value, index));
					handler();
				}}
			>
				Выбрать время
			</button>
		</div>
	);
};

export default TimePopUp;
